var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideModal()
        }
      },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                directives: [
                  { name: "close-overlay", rawName: "v-close-overlay" }
                ],
                attrs: { flat: "", round: "", dense: "", icon: "close" }
              }),
              _c("q-toolbar-title", [
                _vm._v(_vm._s(_vm.$t("add_new_topic").toUpperCase()))
              ])
            ],
            1
          ),
          _c("div", { staticClass: "row q-ma-md" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c(
                  "q-field",
                  { attrs: { count: 256 } },
                  [
                    _c("q-input", {
                      staticClass: "q-my-sm",
                      attrs: {
                        "max-length": "256",
                        "float-label": _vm.$t("topic"),
                        error: _vm.$v.topic.$error
                      },
                      on: { input: _vm.$v.topic.$touch },
                      model: {
                        value: _vm.topic,
                        callback: function($$v) {
                          _vm.topic = $$v
                        },
                        expression: "topic"
                      }
                    })
                  ],
                  1
                ),
                _c("span", { staticClass: "q-my-xs copy" }, [
                  _vm._v(_vm._s(_vm.$t("subject")))
                ]),
                _c("editor", {
                  staticClass: "q-my-sm",
                  attrs: {
                    initialText: _vm.initial_text,
                    editorText: _vm.message,
                    imagePath: _vm.image_path,
                    custom_directory: _vm.custom_directory,
                    imageUpload: _vm.image_upload,
                    id: _vm.new_uid
                  },
                  on: {
                    setMessage: _vm.setMessage,
                    setMessageWithImage: _vm.setMessageWithImage
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "q-toolbar",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c("q-btn", {
                staticClass: "q-mx-sm",
                attrs: {
                  color: "positive",
                  label: _vm.$t("add"),
                  disabled: _vm.topic.length < 4 || _vm.message.length < 4
                },
                on: { click: _vm.addTopic }
              }),
              _c("q-btn", {
                staticClass: "q-mx-sm",
                attrs: { color: "negative", label: _vm.$t("cancel") },
                on: {
                  click: function($event) {
                    return _vm.hideModal()
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }